// extracted by mini-css-extract-plugin
export default {"wrapper":"Logout_wrapper__dM9jL","title":"Logout_title__jD2+N","description":"Logout_description__fJt7z"};